import { render, staticRenderFns } from "./subscription-card.vue?vue&type=template&id=d1a1f56a&scoped=true"
import script from "./subscription-card.vue?vue&type=script&lang=js"
export * from "./subscription-card.vue?vue&type=script&lang=js"
import style0 from "./subscription-card.vue?vue&type=style&index=0&id=d1a1f56a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1a1f56a",
  null
  
)

/* custom blocks */
import block0 from "./subscription-card.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports